module.exports = __webpack_public_path__ + "static/pastor-mental-health-body-1-442bc28ff247cec3e9c6da18dd559e8a.jpg";